/*
 * ZinVolt zakelijke bestellijst
 *
 * Deze controller beheert uitsluitend elementen binnen [data-b2b-page].
 * De algemene themaheader, footer en menustructuur worden hier bewust niet
 * aangepast; de zakelijke paginaschil wordt server-side door Liquid gemaakt.
 */

(function () {
  'use strict';

  var page = document.querySelector('[data-b2b-page]');
  if (!page) return;

  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';
  var currency = page.dataset.currencyCode || 'EUR';
  var products = Array.prototype.slice.call(page.querySelectorAll('[data-b2b-product]'));
  var filterToggle = page.querySelector('[data-b2b-filter-toggle]');
  var filterPanel = page.querySelector('[data-b2b-filter-panel]');
  var searchToggle = page.querySelector('[data-b2b-search-toggle]');
  var searchPanel = page.querySelector('[data-b2b-search-panel]');
  var searchInput = page.querySelector('[data-b2b-search]');
  var searchClear = page.querySelector('[data-b2b-search-clear]');
  var emptyState = page.querySelector('[data-b2b-empty]');
  var currentFilter = 'all';
  var searchTerm = '';

  function parsePositiveInteger(value) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return 1;
    return Math.min(parsed, 9999);
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(window.ZinVoltI18n.locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return '€ ' + (window.ZinVoltI18n.isEnglish ? (cents / 100).toFixed(2) : (cents / 100).toFixed(2).replace('.', ','));
    }
  }

  function updateCardQuantity(card, nextValue) {
    var quantity = parsePositiveInteger(nextValue);
    var input = card.querySelector('[data-qty-input]');
    var hiddenInput = card.querySelector('[data-hidden-qty]');
    var priceOutput = card.querySelector('[data-price-output]');
    var warning = card.querySelector('[data-stock-warning]');
    var unitPrice = parseInt(card.dataset.unitPrice || '0', 10);
    var stock = parseInt(card.dataset.stock || '0', 10);
    var tracksInventory = card.dataset.tracksInventory === 'true';

    if (input) input.value = String(quantity);
    if (hiddenInput) hiddenInput.value = String(quantity);
    if (priceOutput) priceOutput.textContent = formatMoney(unitPrice * quantity);
    if (warning) warning.hidden = !(tracksInventory && quantity > stock);
  }

  function setupQuantity(card) {
    var input = card.querySelector('[data-qty-input]');
    var minus = card.querySelector('[data-qty-minus]');
    var plus = card.querySelector('[data-qty-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        updateCardQuantity(card, parsePositiveInteger(input.value) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        updateCardQuantity(card, parsePositiveInteger(input.value) + 1);
      });
    }

    input.addEventListener('input', function () {
      updateCardQuantity(card, input.value);
    });

    input.addEventListener('blur', function () {
      updateCardQuantity(card, input.value);
    });

    updateCardQuantity(card, input.value);
  }

  function updateVisibleProducts() {
    var visibleCount = 0;

    products.forEach(function (product) {
      var matchesFilter = currentFilter === 'all' || product.dataset.b2bAvailability === currentFilter;
      var productSearch = (product.dataset.b2bSearch || '').toLocaleLowerCase(window.ZinVoltI18n.locale);
      var matchesSearch = !searchTerm || productSearch.indexOf(searchTerm) !== -1;
      var visible = matchesFilter && matchesSearch;

      product.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (emptyState) emptyState.hidden = visibleCount !== 0;
  }

  function setPanel(toggle, panel, open) {
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  function closePanels(except) {
    if (except !== 'filter') setPanel(filterToggle, filterPanel, false);
    if (except !== 'search') setPanel(searchToggle, searchPanel, false);
  }

  function setupPanels() {
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var willOpen = filterToggle.getAttribute('aria-expanded') !== 'true';
        closePanels('filter');
        setPanel(filterToggle, filterPanel, willOpen);
      });
    }

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var willOpen = searchToggle.getAttribute('aria-expanded') !== 'true';
        closePanels('search');
        setPanel(searchToggle, searchPanel, willOpen);
        if (willOpen && searchInput) window.setTimeout(function () { searchInput.focus(); }, 0);
      });
    }

    page.querySelectorAll('[data-b2b-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        currentFilter = button.dataset.b2bFilter || 'all';
        page.querySelectorAll('[data-b2b-filter]').forEach(function (candidate) {
          var active = candidate === button;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        updateVisibleProducts();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        searchTerm = searchInput.value.trim().toLocaleLowerCase(window.ZinVoltI18n.locale);
        if (searchClear) searchClear.hidden = !searchTerm;
        updateVisibleProducts();
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        if (!searchInput) return;
        searchInput.value = '';
        searchTerm = '';
        searchClear.hidden = true;
        updateVisibleProducts();
        searchInput.focus();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanels();
    });
  }

  function updateLocalCartCount(count, totalPrice) {
    var shellCount = page.querySelector('.b2b-shell__cart .cart-count-bubble span[aria-hidden="true"]');
    var shellAccessibleCount = page.querySelector('.b2b-shell__cart .cart-count-bubble .visually-hidden');
    var checkoutBar = page.querySelector('[data-b2b-checkout-bar]');
    var checkoutCount = page.querySelector('[data-b2b-checkout-count]');
    var checkoutTotal = page.querySelector('[data-b2b-checkout-total]');

    if (shellCount) shellCount.textContent = String(count);
    if (shellAccessibleCount) {
      shellAccessibleCount.textContent = count === 1
        ? window.ZinVoltI18n.t("1_item_in_cart_6d6122")
        : window.ZinVoltI18n.t("count_items_in_cart_667968", {count});
    }

    if (checkoutBar) checkoutBar.hidden = count < 1;
    if (checkoutCount) {
      checkoutCount.textContent = count === 1
        ? window.ZinVoltI18n.t("1_product_selected_16e4c5")
        : window.ZinVoltI18n.t("count_products_selected_d1e01d", {count});
    }
    if (checkoutTotal && Number.isFinite(totalPrice)) {
      checkoutTotal.textContent = formatMoney(totalPrice);
    }
  }

  function syncCartCount() {
    return fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error(window.ZinVoltI18n.t("the_cart_could_not_be_updated_280637"));
        return response.json();
      })
      .then(function (cart) {
        updateLocalCartCount(cart.item_count || 0, cart.total_price || 0);
        return cart;
      });
  }

  function setupCartSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'b2b-quick-order') return;
      syncCartCount().catch(function () {});
    });
  }

  function setAddState(button, message, state, text) {
    var label = button ? button.querySelector('span') : null;
    if (!button) return;

    button.classList.toggle('is-loading', state === 'loading');
    button.classList.toggle('is-added', state === 'added');
    button.disabled = state === 'loading';
    if (label && text) label.textContent = text;
    if (message) message.textContent = state === 'error' ? text : '';
  }

  function setupAddForm(card) {
    var form = card.querySelector('[data-b2b-add-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('.b2b-add-button');
      var message = form.querySelector('[data-add-message]');
      var input = card.querySelector('[data-qty-input]');
      var quantity = parsePositiveInteger(input ? input.value : 1);
      var originalText = button && button.querySelector('span')
        ? button.querySelector('span').textContent
        : window.ZinVoltI18n.t("add_to_cart_3273d8");
      var cartDrawer = document.querySelector('cart-drawer');
      var formData = new FormData(form);

      formData.set('quantity', String(quantity));

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (section) { return section.id; }).join(',')
        );
        formData.append('sections_url', window.location.pathname);
      }

      setAddState(button, message, 'loading', window.ZinVoltI18n.t("adding_774ee6"));

      fetch(
        window.routes && window.routes.cart_add_url
          ? window.routes.cart_add_url
          : root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        }
      )
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || window.ZinVoltI18n.t("this_product_could_not_be_added_1b7670"));
            }
            return data;
          });
        })
        .then(function (response) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'b2b-quick-order',
              productVariantId: form.dataset.variantId,
              cartData: response
            });
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response, { open: false });
          }

          setAddState(button, message, 'added', window.ZinVoltI18n.t("added_064829"));
          return syncCartCount();
        })
        .then(function () {
          window.setTimeout(function () {
            setAddState(button, message, 'idle', originalText);
          }, 1800);
        })
        .catch(function (error) {
          setAddState(button, message, 'error', error.message || window.ZinVoltI18n.t("something_went_wrong_please_try_again_de7ebd"));
          window.setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.classList.remove('is-loading', 'is-added');
              var label = button.querySelector('span');
              if (label) label.textContent = originalText;
            }
          }, 2600);
        });
    });
  }

  products.forEach(function (card) {
    setupQuantity(card);
    setupAddForm(card);
  });

  setupPanels();
  setupCartSync();
  updateVisibleProducts();
  updateLocalCartCount(
    parseInt(page.dataset.initialCartCount || '0', 10),
    parseInt(page.dataset.initialCartTotal || '0', 10)
  );
})();
